
import {
  TOOLTIP_SEND_FILE,
  CLOSE,
  FILE,
  SEND_FILE_TRANSFERRED,
  SELECT_FILE_TO_SEND,
  SIZE_EXCEEDED,
  SEND_FILE_SUCCESS,
  SEND_FILE_FAIL,
  TRANSFER_INTERRUPTED,
  RETRY,
} from '../../../constants/languages'

const createFileTransferText = texts => ({
  sendButton: texts[TOOLTIP_SEND_FILE],
  closeButton: texts[CLOSE],
  fileLabel: texts[FILE],
  transferred: texts[SEND_FILE_TRANSFERRED],
  pleaseSelectFile: texts[SELECT_FILE_TO_SEND],
  sizeExceeded: texts[SIZE_EXCEEDED],
  sendFileSuccess: texts[SEND_FILE_SUCCESS],
  sendFileFail: texts[SEND_FILE_FAIL],
  sendFileInterrupted: texts[TRANSFER_INTERRUPTED],
  retry: texts[RETRY],
});

export default createFileTransferText;
